import React from 'react';
import { PackageIcon } from '@fronton/icons-react';
import { Typography } from 'fronton-react';
import styles from './styles.module.css';
/**
 * Компонент OnlineOrderOnly для отображения текста 'Только онлайн заказ'.
 *
 * @param {Object} props - Свойства компонента.
 * @param {String} props.className - имя CSS класса.
 * @param {String} props.text - Отображаемый текст
 * @returns {React.ReactElement} Возвращает текст с иконкой.
 */
export const OnlineOrderOnly = ({ className, text, ...htmlProps }) => (React.createElement("div", { className: `${styles.container} ${className}`, ...htmlProps },
    React.createElement(PackageIcon, { type: "outline", size: "s", color: "secondary-blue-primary" }),
    React.createElement(Typography, { variant: "caption", color: "secondary-blue-primary" }, text)));
//# sourceMappingURL=online-order-only.js.map